// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ao0B6","tabsBox":"styles_tabsBox__1nStC","createButton":"styles_createButton__2wep5"};